import React from 'react'
import Container from './Components/Container'
import './styles.scss'

const AllConversations = (props: any) => <Container {...props} />
export default AllConversations
